module.exports = __webpack_public_path__ + "static/media/p95-lvrg-logo.82acd20b.png";